// extracted by mini-css-extract-plugin
export default {"inline-loader":"SearchWidget_inline-loader__XMgTf","spin":"SearchWidget_spin__gtL6G","base":"SearchWidget_base__2OEX7","eightshimmer":"SearchWidget_eightshimmer__MqoWq"};